import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 15\" id=\"search\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#A4A4AD\" stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"translate(1 1)\"><circle cx=\"6.222\" cy=\"6.222\" r=\"6.222\" /><path d=\"M14 14l-3.383-3.383\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol